// Build-time feature switches. Vite inlines VITE_* at build, so a flag is a
// property of the deployed bundle, not a runtime toggle.

// AI tutor: the /ai-tutor page, its nav entry and the dashboard teaser. On
// unless the build explicitly sets VITE_AI_TUTOR_ENABLED=false — production
// ships it off until the Anthropic-backed `ai-tutor` function is provisioned.
export const aiTutorEnabled = import.meta.env.VITE_AI_TUTOR_ENABLED !== "false";
